import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxtonumber">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtonumber')}
            </Typography>
            <p><strong>{translate('fxtonumber')}</strong> 任意の値のデータ型を変換して数値を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の値</td>
                                <td>"123"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToNumber("123") returns 123</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxrandom">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxrandom')}
            </Typography>
            <p><strong>{translate('fxrandom')}</strong> 0 から 1 までの数値を返します。0 は含まれますが、1 は含まれません。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Random() returns 0.3854957762489586</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtoceiling">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtoceiling')}
            </Typography>
            <p><strong>{translate('fxtoceiling')}</strong> 次の整数に四捨五入した数値を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('number')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>任意の数字</td>
                                <td>1.25</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToCeiling(1.25) returns 2</div>
                    <div>2. ToCeiling(4.75) returns 5</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtofloor">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtofloor')}
            </Typography>
            <p><strong>{translate('fxtofloor')}</strong> 次に低い整数に切り捨てられた数値を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('number')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>任意の数字</td>
                                <td>1.25</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToFloor(1.25) returns 1</div>
                    <div>2. ToFloor(4.75) returns 4</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);